import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderComponent from '../modules/Shared/components/HeaderComponent';
import ModalAddBuilderComponent from '../modules/Shared/modals/ModalAddBuilderComponent';
import { PlusOutlined, ArrowLeftOutlined, DeleteOutlined } from '@ant-design/icons';
import { Modal, Divider, Table, Button, Form, Input, Select, message, Spin, Typography } from 'antd';
import { NumericFormat } from 'react-number-format';
import axios from "./../services/http";
const { Option } = Select;

const PendientesAutorizar = ({ obra }) => {

    const [form] = Form.useForm();
    const [contratistaForm] = Form.useForm();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [openDialog, setOpenDialog] = useState(false);
    const [openDialogContratista, setOpenDialogContratista] = useState(false);
    const [contratistas, setContratistas] = useState([]);
    const [controlesDePago, setControlesDePago] = useState([]);
    const [pendienteList, setPendienteList] = useState([]);
    const [selectedContratista, setSelectedContratista] = useState();
    const [disabledIVA, setDisabledIVA] = useState(false);
    const numberFormat = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 });

    const totalsAut = useMemo(() => {
        let sumTotal = 0, sumContratoF = 0, sumContratoNF = 0;
        let sumRegF = 0, sumRegNF = 0, sumRestF = 0, sumRestNF = 0, sumTotalRest = 0;
        pendienteList.forEach((p) => {
            sumTotal += p.total || 0;
            sumContratoF += p.contratoFiscal || 0;
            sumContratoNF += p.contratoNoFiscal || 0;
            sumRegF += p.registradoFiscal || 0;
            sumRegNF += p.registradoNoFiscal || 0;
            let rF = (p.contratoFiscal || 0) - (p.registradoFiscal || 0);
            let rNF = (p.contratoNoFiscal || 0) - (p.registradoNoFiscal || 0);
            sumRestF += rF;
            sumRestNF += rNF;
            sumTotalRest += rF + rNF;
        });
        return { sumTotal, sumContratoF, sumContratoNF, sumRegF, sumRegNF, sumRestF, sumRestNF, sumTotalRest };
    }, [pendienteList]);

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id_pendiente',
            key: 'id_pendiente',
            fixed: 'left',
        },
        {
            title: 'Concepto',
            dataIndex: 'concepto',
            key: 'concepto',
        },
        {
            title: 'Contratista',
            dataIndex: 'contratista',
            key: 'contratista',
        },
        {
            title: 'Total',
            dataIndex: 'total',
            key: 'total',
            render: (total) => `$ ${numberFormat.format(total)}`,
        },
        {
            title: 'IVA',
            dataIndex: 'iva',
            key: 'iva',
            render: (iva) => `${numberFormat.format(iva)}%`,
        },
        {
            title: 'Contrato Fiscal',
            dataIndex: 'contratoFiscal',
            key: 'contratoFiscal',
            render: (contratoFiscal) => `$ ${numberFormat.format(contratoFiscal)}`,
        },
        {
            title: 'Contrato No Fiscal',
            dataIndex: 'contratoNoFiscal',
            key: 'contratoNoFiscal',
            render: (contratoNoFiscal) => `$ ${numberFormat.format(contratoNoFiscal)}`,
        },
        {
            title: 'Registrado Fiscal',
            dataIndex: 'registradoFiscal',
            key: 'registradoFiscal',
            render: (registradoFiscal) => `$ ${numberFormat.format(registradoFiscal)}`,
        },
        {
            title: 'Registrado No Fiscal',
            dataIndex: 'registradoNoFiscal',
            key: 'registradoNoFiscal',
            render: (registradoNoFiscal) => `$ ${numberFormat.format(registradoNoFiscal)}`,
        },
        {
            title: 'Restante Fiscal',
            dataIndex: 'restanteFiscal',
            key: 'restanteFiscal',
            render: (_, payment) => {
                let restante = numberFormat.format((payment.contratoFiscal - payment.registradoFiscal));
                return <>$ {restante}</>
            }
        },
        {
            title: 'Restante No Fiscal',
            dataIndex: 'restanteNoFiscal',
            key: 'restanteNoFiscal',
            render: (_, payment) => {
                let restante = numberFormat.format((payment.contratoNoFiscal - payment.registradoNoFiscal));
                return <>$ {restante}</>
            }
        },
        {
            title: 'Total Restante',
            dataIndex: 'totalRestante',
            key: 'totalRestante',
            render: (_, payment) => {
                let restanteFiscal = payment.contratoFiscal - payment.registradoFiscal;
                let restanteNoFiscal = payment.contratoNoFiscal - payment.registradoNoFiscal;
                let restante = numberFormat.format(restanteFiscal + restanteNoFiscal);
                return <>$ {restante}</>
            }
        },
        {
            title: 'Acciones',
            dataIndex: 'actions',
            key: 'actions',
            render: ((_, payment) =>
                <>
                    <div style={{ textAlign: "center" }}>
                        <Button color="danger" variant="filled" onClick={() => EliminarPendiente(payment)}>
                            <DeleteOutlined />
                        </Button>
                    </div>
                </>
            )
        }
    ];

    useEffect(() => {
        fetchContratistas();
        fetchPendientesPorAutorizar();
    }, [obra]);

    const fetchContratistas = async () => {
        setLoading(true);
        try {
            const response = await axios.HTTP_GET(`/api/v1/catalogs/contratistas/${obra.id}`);
            if (response) setContratistas(response);
        } catch (error) {
            console.error('Error al cargar los contratistas:', error);
            message.error('Error al cargar los contratistas');
        } finally {
            setLoading(false);
        }
    };

    const fetchPendientesPorAutorizar = async () => {
        setLoading(true);
        try {
            const response = await axios.HTTP_GET(`/api/v1/payments/pendingToRelationship/${obra.id}/AUTORIZAR`);
            if (response) {
                setPendienteList(response);
            }
        } catch (e) {
            console.error('Error al obtener los pendientes por autorizar:', e);
            message.error('Error al obtener los pendientes por autorizar');
            setPendienteList([]);
        } finally {
            setLoading(false);
        }
    }

    const fetchControlesDePago = async (contratistaId) => {
        setLoading(true);
        try {
            let data = [];
            const response = await axios.HTTP_GET(`/api/v1/catalogs/controlesdepago/${obra.id}/${contratistaId}`);
            if (response) {
                data = response;
                setControlesDePago(data);
            }

        } catch (error) {
            console.error('Error al obtener los controles de pago:', error);
            message.error('Error al obtener los controles de pago');
            setControlesDePago([]);
        } finally {
            setLoading(false);
        }
    };

    const handleContratistaChange = (value) => {
        const contratistaId = value;
        setSelectedContratista(contratistaId);
        fetchControlesDePago(contratistaId);
    };

    const onValuesChange = (changedValues) => {
        if ('contratoFiscal' in changedValues) {
            let contratoFiscal = changedValues.contratoFiscal;
            if (typeof contratoFiscal === "string") {
                contratoFiscal = parseFloat(contratoFiscal.replace(/[$,]/g, '')).toFixed(2);
                if (contratoFiscal === "0.00") setDisabledIVA(true);
                else setDisabledIVA(false);
            }
        }
    };

    const handlePendientes = async (values) => {
        console.log("values", values)
        const nuevoPendienteRelacionar = {
            obra_id: obra.id,
            obra_nombre: obra.nombre_obra,
            concepto: values.concepto,
            id_pendiente: values.id_pendiente,
            contratista_id: values.contratista_id,
            total: (typeof values.total === "string" ? parseFloat(values.total.replace(/[$,]/g, '')).toFixed(2) : values.total),
            iva: (typeof values.iva === "string" ? parseFloat(values.iva).toFixed(2) : values.iva),
            contratoFiscal: (typeof values.contratoFiscal === "string" ? parseFloat(values.contratoFiscal.replace(/[$,]/g, '')).toFixed(2) : values.contratoFiscal),
            contratoNoFiscal: (typeof values.contratoNoFiscal === "string" ? parseFloat(values.contratoNoFiscal.replace(/[$,]/g, '')).toFixed(2) : values.contratoNoFiscal),
            registradoFiscal: (typeof values.registradoFiscal === "string" ? parseFloat(values.registradoFiscal.replace(/[$,]/g, '')).toFixed(2) : values.registradoFiscal),
            registradoNoFiscal: (typeof values.registradoNoFiscal === "string" ? parseFloat(values.registradoNoFiscal.replace(/[$,]/g, '')).toFixed(2) : values.registradoNoFiscal),
            tipo: "AUTORIZAR"
        };

        const response = await axios.HTTP_POST("/api/v1/payments/pendingToRelationship/save", nuevoPendienteRelacionar);
        if (response) {
            setOpenDialog(false);
            message.success(response.data.message);
            fetchPendientesPorAutorizar();
        }
    }

    const EliminarPendiente = async (payment) => {
        try {
            const response = await axios.HTTP_POST('/api/v1/payments/pendingToRelationship/delete', { id: payment.id });
            if (response && response.data) {
                message.success(response.data.message);
                fetchPendientesPorAutorizar();
            }
        } catch (e) {
            console.error('Error al eliminar pendiente de autorizar:', e);
            message.error('Hubo un error al elminar pendiente de autorizar');
        }
    }

    const Navigate = (path, params) => {
        navigate(path, params);
    }

    {/** FUNCTIONS MODAL ADD BUILDER **/ }
    const cancelBuilderDialog = () => setOpenDialogContratista(false);
    const savedBuilder = (response) => {
        form.setFieldsValue({ contratistaId: response.data.id });
        setContratistas([...contratistas, response.data]);
    }

    return (
        <>
            <HeaderComponent title={`Pendientes de Autorizar - ${obra.nombre_obra}`} />
            <div style={{ width: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                <Button type="primary" shape="round"
                    style={{ "marginBottom": "15px" }}
                    onClick={() => setOpenDialog(true)}
                >
                    <PlusOutlined /> Nuevo pendiente
                </Button>
            </div>
            <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', padding: '12px 16px', background: '#fafafa', border: '1px solid #f0f0f0', borderRadius: 4, marginBottom: 8, fontWeight: 'bold', fontSize: 13 }}>
                <span>TOTALES:</span>
                <span>Total: $ {numberFormat.format(totalsAut.sumTotal)}</span>
                <span>Contrato Fiscal: $ {numberFormat.format(totalsAut.sumContratoF)}</span>
                <span>Contrato No Fiscal: $ {numberFormat.format(totalsAut.sumContratoNF)}</span>
                <span>Reg. Fiscal: $ {numberFormat.format(totalsAut.sumRegF)}</span>
                <span>Reg. No Fiscal: $ {numberFormat.format(totalsAut.sumRegNF)}</span>
                <span>Rest. Fiscal: $ {numberFormat.format(totalsAut.sumRestF)}</span>
                <span>Rest. No Fiscal: $ {numberFormat.format(totalsAut.sumRestNF)}</span>
                <span>Total Restante: $ {numberFormat.format(totalsAut.sumTotalRest)}</span>
            </div>
            <div>
                <Table
                    dataSource={pendienteList}
                    columns={columns}
                    rowKey="id"
                    loading={loading}
                    pagination={false}
                    scroll={{
                        x: 'max-content',
                    }}
                />
            </div>
            <Modal
                title={`Nuevo pendiente por autorizar`}
                open={openDialog}
                onCancel={() => setOpenDialog(false)}
                footer={null}
            >
                <Divider style={{ margin: '24px 0' }} />
                <Form
                    layout="vertical"
                    form={form}
                    onFinish={handlePendientes}
                    onValuesChange={onValuesChange}
                >
                    <Form.Item
                        label="Contratista"
                        name="contratista_id"
                        rules={[{ required: true, message: 'Por favor seleccionar el contratista' }]}
                    >
                        <Select
                            placeholder="Seleccionar Contratista"
                            value={selectedContratista || undefined}
                            onChange={handleContratistaChange}
                            style={{ width: '100%' }}
                            loading={loading}
                            dropdownRender={(menu) => (
                                <>
                                    {menu}
                                    <Button type="link" onClick={() => setOpenDialogContratista(true)}>
                                        Nuevo contratista
                                    </Button>
                                </>
                            )}
                        >
                            {contratistas.map((contratista) => (
                                <Option key={contratista.id} value={contratista.id}>
                                    {contratista.nombre_contratista}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                    {selectedContratista && (
                        <>
                            <Form.Item
                                label="Concepto"
                                name="concepto"
                                rules={[{ required: true, message: 'Por favor ingresar el concepto' }]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label="ID"
                                name="id_pendiente"
                                rules={[{ required: true, message: 'Por favor ingresar el id' }]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label="Total"
                                name="total"
                                rules={[{ required: true, message: 'Por favor ingresar el total' }]}
                            >
                                <NumericFormat
                                    thousandSeparator={true} prefix={'$ '}
                                    customInput={Input}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Contrato Fiscal"
                                name="contratoFiscal"
                                rules={[{ required: true, message: 'Por favor ingresar el contrato fiscal' }]}
                            >
                                <NumericFormat
                                    thousandSeparator={true} prefix={'$ '}
                                    customInput={Input}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Contrato No Fiscal"
                                name="contratoNoFiscal"
                                rules={[{ required: true, message: 'Por favor ingresar el contrato no fiscal' }]}
                            >
                                <NumericFormat
                                    thousandSeparator={true} prefix={'$ '}
                                    customInput={Input}
                                />
                            </Form.Item>
                            {!disabledIVA ?
                                <Form.Item
                                    label="IVA"
                                    name="iva"
                                    rules={[{ required: true, message: 'Por favor selecciona el IVA' }]}
                                >
                                    <Select placeholder="Selecciona una opción" disabled={disabledIVA}>
                                        <Select.Option value={8}>8%</Select.Option>
                                        <Select.Option value={16}>16%</Select.Option>
                                    </Select>
                                </Form.Item>
                                : null}
                            <Form.Item
                                label="Registrado Fiscal"
                                name="registradoFiscal"
                                rules={[{ required: true, message: 'Por favor ingresar el registrado fiscal' }]}
                            >
                                <NumericFormat
                                    thousandSeparator={true} prefix={'$ '}
                                    customInput={Input}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Registrado No Fiscal"
                                name="registradoNoFiscal"
                                rules={[{ required: true, message: 'Por favor ingresar el registrado no fiscal' }]}
                            >
                                <NumericFormat
                                    thousandSeparator={true} prefix={'$ '}
                                    customInput={Input}
                                />
                            </Form.Item>
                        </>
                    )}

                    <Divider style={{ margin: '24px 0' }} />
                    <Form.Item>
                        <div style={{ display: 'flex', justifyContent: 'end', gap: '10px' }}>
                            <Button type="default" onClick={() => setOpenDialog(false)}>
                                Cancelar
                            </Button>
                            <Button type="primary" loading={loading} htmlType="submit">
                                Guardar
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </Modal>

            {/** INIT MODAL ADD BUILDER **/}
            <ModalAddBuilderComponent
                obra={obra}
                openDialogContratista={openDialogContratista}
                cancelBuilderDialog={cancelBuilderDialog}
                savedBuilder={savedBuilder}
            />
            {/** END MODAL ADD BUILDER **/}
        </>
    )
}

export default PendientesAutorizar;